// translations/pages/events/ja.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageJA = {
  title: 'イベント',
  upcoming: '今後のイベント',
  past: '過去のイベント',
  all: 'すべてのイベント',
  items: {
    wikki26: {
      title: 'WiKKI26 – ヴィルダウ人工知能カンファレンス',
      description: 'pAIoneer Labsは、Technische Hochschule Wildau（ヴィルダウ工科大学）に出展しました。ブースでは、企業や組織でローカルAIインフラをどのように構築するかをテーマとしました。データ主権、設計段階からのデータ保護、法令に準拠したAIを、外部のクラウドソリューションに不必要に依存することなく実現するという内容です。'
    }
  }
};
